<template>
    <el-row class="box-roles mt-3">
        <el-col :span="24">
            <InputField :label-text="$t('member.shareName')" is-required>
                <InputText classes="w-100" v-model="dataShare.shareName"> </InputText>
                <template #error v-if="errorShareName">{{ errorShareName }}</template>
            </InputField>
            <div class="mt-3">
                <div class="box-filter__label">{{ $t('filter.filterTitle') }}</div>
                <div class="box-filter__items padding_disable">
                    <div class="d-flex flex-row align-items-center padding-10 text-bold" v-if="filterContents.length > 0">
                        <div class="mr-3 labelFilter1">{{ $t('filter.content1') }}</div>
                        <div class="mr-3 labelFilter2">{{ $t('filter.content2') }}</div>
                        <div class="labelFilter3">{{ $t('filter.content3Step4') }}</div>
                    </div>
                    <div class="box-filter__item" v-for="(settingFilter, index) in filterContents" :key="index">
                        <div class="mr-3 contentFilter1">
                            <SelectCustom classes="w-full" :filterable="false" v-model="settingFilter.field">
                                <template #options>
                                    <el-option v-for="(item, index) in listFilters" :key="index + 'field'" :label="item.label" :value="item.code">
                                        {{ item.label }}
                                    </el-option>
                                </template>
                            </SelectCustom>
                        </div>
                        <div class="mr-3 contentFilter2">
                            <SelectCustom classes="w-full" :filterable="false" v-model="settingFilter.condition_type">
                                <template #options>
                                    <el-option v-for="(item, index) in listTypeConditions" :key="index + 'condition'" :label="item.label" :value="item.value">
                                        {{ item.label }}
                                    </el-option>
                                </template>
                            </SelectCustom>
                        </div>
                        <div class="contentFilter3 input-options">
                            <SelectCustom classes="w-100" :filterable="false" v-model="settingFilter.user_field">
                                <template #options>
                                    <el-option v-for="(item, index) in userFields" :value="item.value" :label="item.label" :key="index + 'user_field'">
                                        {{ item.label }}
                                    </el-option>
                                </template>
                            </SelectCustom>
                        </div>
                        <i class="el-icon-remove icon-remote color-remove-filter" @click="onDeleteFieldFilter(index)"></i>
                    </div>
                    <div class="box-filter__item-add icon-remote" @click="onAddFilterField">
                        <el-icon class="el-icon-circle-plus"></el-icon>
                    </div>
                    <div class="box-filter__item-condition">
                        <RadioList v-model="dataShare.condition_setting" :data-list="listTypeFilters"></RadioList>
                    </div>
                </div>
            </div>
            <InputField classes="mt-3" :label-text="$t('member.role')" is-required>
                <div class="d-sm-flex d-block align-items-center w-100 pl-0 mt-2">
                    <div class="list-roles">
                        <label class="ckbox" v-for="roleItem in listRoles" :key="roleItem.type">
                            <input :disabled="roleItem.value === 1" v-model="dataShare.rolesMultiFilter" type="checkbox" :value="roleItem.value" />
                            <span>{{ $t(roleItem.label) }}</span>
                        </label>
                    </div>
                </div>
            </InputField>
        </el-col>
    </el-row>
</template>
<script>
import SelectCustom from '@/components/partials/customs/SelectCustom';
import InputField from '@/components/partials/InputField';
import InputText from '@/components/partials/customs/InputText';
import { mapState } from 'vuex';
import { TYPE_PLAN_READONLY } from '@/config/constants';
import RadioList from '@/components/partials/RadioList.vue';

export default {
    name: 'form-multi-filter',
    props: {
        data: {
            type: Object,
            required: true,
            default: () => {}
        },
        userFields: {
            type: Array,
            required: false,
            default: () => []
        },
        settingMultiFilter: {
            type: Array,
            required: true,
            default: () => []
        },
        errorShareName: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: {
        RadioList,
        InputText,
        InputField,
        SelectCustom
    },
    data() {
        return {
            dataShare: this.data,
            listFilters: JSON.parse(localStorage.getItem('listFiltersStep4')),
            filterContents: this.data.filterContents,
            listTypeConditions: [{ value: '=', label: this.$t('filter.condition1') }]
        };
    },
    created() {},
    computed: {
        ...mapState('auth', ['userInfo']),
      listTypeFilters() {
        return [
          { value: 'and', label: this.$t('filter.allFilter') },
          { value: 'or', label: this.$t('filter.anyFilter') }
        ];
      },
        listRoles() {
            if (this.userInfo.plan.type_plan === TYPE_PLAN_READONLY) {
                return [{ label: 'member.roles.view', value: 1 }];
            } else {
                return [
                    { label: 'member.roles.view', value: 1 },
                    { label: 'member.roles.edit', value: 3 },
                    { label: 'member.roles.register', value: 2 },
                    { label: 'member.roles.export', value: 5 }
                ];
            }
        },
        watchFilterContentandUserField() {
            return [this.filterContents, this.userFields];
        }
    },
    watch: {
        dataShare: {
            deep: true,
            handler(val) {
                this.$emit('update:data', val);
            }
        },
        watchFilterContentandUserField: {
            deep: true,
            immediate: true,
            handler(val) {
                let settingMultiFilter = [];
                this.filterContents.forEach((item) => {
                    let data = this.listFilters.find((element) => element?.code === item.field);
                    let dataFieldUser = this.userFields.find((element) => {
                        return element.value === item.user_field;
                    });
                    if (data && dataFieldUser) {
                        settingMultiFilter.push({
                            field: data.code,
                            field_name: data.label,
                            field_type: data.type,
                            condition_type: item.condition_type,
                            user_field: item.user_field,
                            user_field_name: dataFieldUser.label
                        });
                    }
                });
                this.$emit('update:settingMultiFilter', settingMultiFilter);
            }
        }
    },
    methods: {
        onAddFilterField() {
            this.filterContents.push({
                field: '',
                condition_type: '',
                user_field: ''
            });
        },

        onDeleteFieldFilter(index) {
            this.filterContents.splice(index, 1);
        },

        mapSetting(setting) {}
    }
};
</script>

<style lang="scss" scoped>
.padding_disable {
    padding: 0 !important;
}

.color-remove-filter {
    color: #cccccc !important;
}
</style>
